import { useEffect, useState } from 'react';

function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const updateStickyState = () => setIsSticky(window.scrollY > 20);

    updateStickyState();
    window.addEventListener('scroll', updateStickyState, { passive: true });

    return () => window.removeEventListener('scroll', updateStickyState);
  }, []);

  useEffect(() => {
    if (!isMenuOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setIsMenuOpen(false);
    };
    const closeOnDesktop = () => {
      if (window.innerWidth >= 992) setIsMenuOpen(false);
    };

    document.body.classList.add('menu-open');
    window.addEventListener('keydown', closeOnEscape);
    window.addEventListener('resize', closeOnDesktop);

    return () => {
      document.body.classList.remove('menu-open');
      window.removeEventListener('keydown', closeOnEscape);
      window.removeEventListener('resize', closeOnDesktop);
    };
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className={`site-header${isSticky ? ' is-sticky' : ''}`}>
      <div className="container header-container">
        <div className="row">
          <div className="col-12">
          <nav
            className="navbar navbar-expand-lg floating-nav"
            aria-label="Main navigation"
          >
            <div className={`nav-shell${isSticky ? ' container' : ''}`}>
              <a className="brand" href="#top" aria-label="Home">
                <img src="/assets/images/logo.png" alt="Designs By Arushi" />
              </a>

              <button
                className="navbar-toggler"
                type="button"
                aria-controls="navLinks"
                aria-expanded={isMenuOpen}
                aria-label="Toggle navigation"
                onClick={() => setIsMenuOpen((open) => !open)}
              >
                <span className="menu-icon" aria-hidden="true">
                  <span />
                  <span />
                  <span />
                </span>
              </button>

              <div className={`navbar-collapse mobile-nav-panel${isMenuOpen ? ' is-open' : ''}`} id="navLinks">
                <div className="mobile-nav-header">
                  <span className="mobile-nav-label">Navigation</span>
                  <button className="mobile-nav-close" type="button" aria-label="Close navigation" onClick={closeMenu}>
                    <i className="fa-solid fa-xmark" aria-hidden="true" />
                  </button>
                </div>
                <ul className="navbar-nav mx-auto nav-links">
                  <li className="nav-item">
                    <a className="nav-link" href="#story" onClick={closeMenu}>
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#shop" onClick={closeMenu}>
                      Projects
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#services" onClick={closeMenu}>
                      Services
                    </a>
                  </li>
                </ul>

                <a
                  className="contact-link"
                  href="#contact"
                  data-bs-toggle="modal"
                  data-bs-target="#queryModal"
                  onClick={closeMenu}
                >
                  Contact Us
                  <span aria-hidden="true">
                    <i className="fa-solid fa-arrow-right" />
                  </span>
                </a>
              </div>
            </div>
          </nav>
          </div>
        </div>
      </div>
      <button className={`mobile-nav-backdrop${isMenuOpen ? ' is-open' : ''}`} type="button" aria-label="Close navigation" onClick={closeMenu} />
    </header>
  );
}

export default Header;
